import React from 'react';
import { Tooltip } from 'antd';

interface CustomTooltipProps {
  field: any;
  children: React.ReactElement;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ field, children }) => {
  const tooltipContent = field.tooltipImage ? (
    <div style={{ position: 'relative' }}>
      <img
        src={field.tooltipImage}
        alt='Ejemplo'
        style={{
          maxWidth: 200,
          maxHeight: 200,
          display: 'block',
          objectFit: 'contain'
        }}
      />
    </div>
  ) : (
    field.tooltip
  );

  return (
    <Tooltip title={tooltipContent} placement='topRight' mouseEnterDelay={0.6}>
      {children}
    </Tooltip>
  );
};
